import Vue from "vue";
import Vuex from "vuex";

import Account from "./modules/account";
import Alert from "./modules/alert";
import Allocation from "./modules/allocation";
import Breadcrumb from "./modules/breadcrumb";
import Contact from "./modules/contact";
import CustomDashboard from "./modules/customDashboard";
import DashBoard from "./modules/dashBoard";
import ExecutiveSummary from "./modules/executiveSummary";
import Finance from "./modules/finance";
import Loading from "./modules/loading";
import LogIn from "./modules/logIn";
import Notification from "./modules/notification";
import Product from "./modules/product";
import User from "./modules/user";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    LogIn,
    Breadcrumb,
    Alert,
    Notification,
    Loading,
    DashBoard,
    CustomDashboard,
    Allocation,
    Account,
    Contact,
    Product,
    Finance,
    ExecutiveSummary,
    User,
  },
  strict: true,
});

export default store;
